import { Directive, ElementRef, Input, OnInit } from
    '@angular/core';

import * as $ from 'jquery';

const template = '<div class="popover" role="tooltip">' +
    '<div class="arrow"></div>' +
    '<h3 class="popover-title"></h3>' +
    '<div class="popover-content" style="max-height: 200px !important; overflow-y: auto !important;"</div > ' +
    '</div>';

@Directive({
    selector: '[gf-popover]'
})
export class PopoverDirective implements OnInit {
    @Input() placement: string = 'top';
    @Input() allowClickEvent: boolean;
    @Input() trigger = 'click';
    @Input('gf-popover') content: string;
    @Input('html-title') htmlTitle: string;

    constructor(private elementRef: ElementRef) {}

    ngOnInit(): void {

        const elem = $(this.elementRef.nativeElement);
        const content = this.content ?? elem.attr('data-content');

        const params = { html: true, placement: this.placement, template: template, content: content, trigger: this.trigger };
        (elem as any).popover(params);

        const htmlTitle = this.htmlTitle ?? elem.attr('html-title');
        if (htmlTitle == undefined) {
            elem.attr('title', 'Click for details');
        } else {
            elem.attr('title', htmlTitle);
        }

        if (!this.allowClickEvent) { //This allows to add ng-click events on the same element as the popover
            elem.bind('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
        }
    }
}
